<template>
  <div class="app-body">
    <MakeDetailTable queryType="seller" :hide-query="['orderCode']"></MakeDetailTable>
  </div>
</template>

<script>
import MakeDetailTable from '@/views/modules/erp/client/common/make/make-detail-table.vue'

export default {
  mixins: [],
  components: { MakeDetailTable },
  data () {
    return {}
  },
  methods: {},
}
</script>
